import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import { DoctorIcon } from '../icons/doctor';

export const HeaderMainMenu: React.FC = () => {
  const { key } = useOrgContext();
  const { t } = useTranslation(key);
  const analytics = useAnalytics();
  return (
    <div className={'relative border-b border-gray-200 bg-white'}>
      <div className={'mf-wrap'}>
        <div
          className={
            'lg:landscape:min-h-[5.125rem] xl:min-h-[5.125rem] flex min-h-[3.625rem] items-center justify-between py-4'
          }
        >
          {/* Hamburger Menu */}
          <div
            className={
              'lg:landscape:-left-24 xl:-left-24 relative flex items-center'
            }
          >
            <a
              href={'https://montefioreeinstein.org/'}
              className={
                'mf-button mf-button--site-montefiore mf-button--light mf-button--base mf-button--rounded mf-top-bar__button mf-top-bar__button--icon mf-top-bar__button--burger inline-block align-bottom'
              }
              aria-label={t('aria.openNavigationMenu')}
              data-analytics-click-text={'Menu'}
              data-analytics-link-type={'button'}
              data-analytics-event={'e_navigationOpen'}
              data-analytics-navigation-type={'hamburger'}
            >
              <span className={'mf-button__ripple'}>
                <span
                  className={'mf-button__ripple__path'}
                  style={{ left: '0px', top: '0px' }}
                />
              </span>
              <span className={'mf-button__icon mf-button__icon--leading'}>
                <span
                  className={'mf-icon mf-icon--small mf-icon--inherit'}
                  data-analytics-click-text={'burgermenu'}
                  data-analytics-link-type={'icon'}
                >
                  <span />
                  <span />
                  <span />
                </span>
              </span>
              <span className={'mf-button__text'}>{t('montefiore.menu')}</span>
            </a>
          </div>

          {/* Logo */}
          <div className={'mf-top-bar__logo'}>
            <a
              href={'https://montefioreeinstein.org'}
              onClick={() => {
                analytics.navigationClickEvent({
                  navigationType: 'top-bar',
                  linkType: 'link',
                  clickText: 'Montefiore Einstein',
                });
              }}
              data-analytics-link-type={'logo'}
              data-analytics-click-text={'montefiore-einstein-primary'}
            >
              <Image
                src={
                  'https://montefioreeinstein.org/modules/montefiore_einstein/storybook/static/images/logos/montefiore-einstein-primary.svg'
                }
                alt={t('aria.logoAlt', { orgName: 'Montefiore Einstein' })}
                className={'mf-logo block w-[12.5rem]'}
                data-analytics-link-type={'logo'}
                width={200}
                height={40}
                priority={true}
                quality={100}
              />
            </a>
          </div>

          <div className={'flex items-center'}>
            {/* Search */}
            <a
              href={
                'https://montefioreeinstein.org/search?language=en&filters%5B0%5D=146&autosuggest=0&keyword=&items_per_page=10 '
              }
              onClick={() => {
                analytics.navigationClickEvent({
                  navigationType: 'top-bar',
                  linkType: 'button',
                  clickText: t('montefiore.search'),
                });
              }}
              className={
                'mf-button mf-button--site-montefiore mf-button--light mf-button--base mf-button--rounded mf-top-bar__button mf-top-bar__button--icon mf-top-bar__button--search inline-block align-bottom'
              }
              data-analytics-click-text={'Search'}
              data-analytics-link-type={'button'}
            >
              <span className={'mf-button__ripple'}>
                <span
                  className={'mf-button__ripple__path'}
                  style={{ left: '0px', top: '0px' }}
                />
              </span>
              <span className={'mf-button__icon mf-button__icon--leading'}>
                <span
                  className={'mf-icon mf-icon--small mf-icon--inherit'}
                  data-analytics-click-text={'search'}
                  data-analytics-link-type={'icon'}
                >
                  <span />
                  <span />
                  <span />
                </span>
              </span>
              <span className={'mf-button__text'}>
                {t('montefiore.search')}
              </span>
            </a>

            {/* Find a Doctor */}
            <ul className={'lg:landscape:block xl:block ml-4 hidden list-none'}>
              <li className={'inline-block'}>
                <a
                  onClick={() => {
                    analytics.navigationClickEvent({
                      navigationType: 'top-bar',
                      linkType: 'button',
                      clickText: t('montefiore.findADoctor'),
                    });
                  }}
                  className={
                    'mf-button mf-button--site-montefiore mf-button--ghost-dark mf-button--base mf-button--rounded mf-top-bar__button'
                  }
                  data-analytics-click-text={'Find a Doctor'}
                  data-analytics-link-type={'button'}
                  href={'https://montefioreeinstein.org/profiles'}
                >
                  <span className={'mf-button__ripple'}>
                    <span
                      className={'mf-button__ripple__path'}
                      style={{ left: '0px', top: '0px' }}
                    />
                  </span>
                  <span className={'mf-button__icon mf-button__icon--leading'}>
                    <span
                      className={'mf-icon mf-icon--large mf-icon--inherit'}
                      data-analytics-click-text={'doctor'}
                      data-analytics-link-type={'icon'}
                    >
                      <DoctorIcon
                        className={'mf-icon__svg'}
                        aria-hidden={'true'}
                        focusable={'false'}
                      />
                    </span>
                  </span>
                  <span className={'mf-button__text'}>
                    {t('montefiore.findADoctor')}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
